import { type ApiEnvelope, api, unwrap } from "@/lib/api";

export type WaStatus = "draft" | "scheduled" | "sending" | "sent" | "failed";

export interface WaCampaign {
	id: string;
	name: string;
	templateName: string;
	templateLang: string;
	templateParams: string[];
	segmentId: string | null;
	segmentLabel: string | null;
	status: WaStatus;
	scheduledAt: string | null;
	sentAt: string | null;
	recipients: number;
	sentCount: number;
	failedCount: number;
	estimatedCost: number;
	lastError: string | null;
	updatedAt: string;
	createdAt: string;
}

export interface WaStats {
	optin: number;
	campaigns: number;
	sent: number;
	failed: number;
	deliveryRate: number;
	pricePerMessage: number;
	/** Faux si le jeton Meta est absent ou expiré. */
	connected: boolean;
}

export const whatsappApi = {
	list: () =>
		unwrap<{ items: WaCampaign[] }>(
			api.get<ApiEnvelope<{ items: WaCampaign[] }>>(
				"/admin/whatsapp/campaigns",
			),
		),

	stats: () =>
		unwrap<WaStats>(
			api.get<ApiEnvelope<WaStats>>("/admin/whatsapp/campaigns/stats"),
		),

	create: (payload: {
		name: string;
		templateName: string;
		templateLang?: string;
		templateParams?: string[];
		segmentId?: string;
		scheduledAt?: string;
	}) =>
		unwrap<WaCampaign>(
			api.post<ApiEnvelope<WaCampaign>>("/admin/whatsapp/campaigns", payload),
		),

	schedule: (id: string, at?: string) =>
		unwrap<WaCampaign>(
			api.post<ApiEnvelope<WaCampaign>>(
				`/admin/whatsapp/campaigns/${id}/schedule`,
				at ? { at } : {},
			),
		),

	cancel: (id: string) =>
		unwrap<WaCampaign>(
			api.post<ApiEnvelope<WaCampaign>>(
				`/admin/whatsapp/campaigns/${id}/cancel`,
			),
		),

	duplicate: (id: string) =>
		unwrap<WaCampaign>(
			api.post<ApiEnvelope<WaCampaign>>(
				`/admin/whatsapp/campaigns/${id}/duplicate`,
			),
		),

	remove: (id: string) =>
		unwrap<{ deleted: boolean }>(
			api.delete<ApiEnvelope<{ deleted: boolean }>>(
				`/admin/whatsapp/campaigns/${id}`,
			),
		),
};

export const WA_STATUS_LABELS: Record<
	WaStatus,
	{ label: string; variant: "success" | "info" | "neutral" | "danger" }
> = {
	sent: { label: "Envoyée", variant: "success" },
	sending: { label: "En cours", variant: "info" },
	scheduled: { label: "Programmée", variant: "info" },
	draft: { label: "Brouillon", variant: "neutral" },
	failed: { label: "Échouée", variant: "danger" },
};
